(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = Boolean(window.Shopify && window.Shopify.designMode);

  function reveal() {
    const nodes = document.querySelectorAll('[data-u-reveal]:not(.is-in)');
    if (!nodes.length) return;

    if (designMode || reduce || !('IntersectionObserver' in window)) {
      nodes.forEach((el) => el.classList.add('is-in'));
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    nodes.forEach((el) => io.observe(el));
  }

  function heroParallax() {
    if (reduce) return;
    const hero = document.querySelector('[data-universo-hero]');
    const img = hero && hero.querySelector('.universo-hero__img, .universo-hero__fallback');
    if (!hero || !img) return;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const rect = hero.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          const progress = Math.min(1, Math.max(0, -rect.top / Math.max(rect.height, 1)));
          img.style.transform = `scale(1.04) translate3d(0, ${progress * 36}px, 0)`;
        }
        ticking = false;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function scrollHint() {
    const btn = document.querySelector('[data-universo-scroll]');
    if (!btn) return;
    btn.addEventListener('click', () => {
      const next = document.querySelector('[data-universo-section]');
      if (next) {
        next.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  function momentsDrag() {
    const track = document.querySelector('[data-universo-moments]');
    if (!track) return;

    let down = false;
    let startX = 0;
    let startScroll = 0;

    const start = (clientX) => {
      down = true;
      startX = clientX;
      startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
      track.style.cursor = 'grabbing';
    };
    const move = (clientX) => {
      if (!down) return;
      track.scrollLeft = startScroll - (clientX - startX);
    };
    const end = () => {
      if (!down) return;
      down = false;
      track.style.scrollSnapType = '';
      track.style.cursor = '';
    };

    track.addEventListener('mousedown', (e) => {
      if (e.button !== 0) return;
      start(e.clientX);
    });
    window.addEventListener('mousemove', (e) => move(e.clientX));
    window.addEventListener('mouseup', end);
    track.addEventListener('mouseleave', end);
  }

  function splitParallax() {
    if (reduce) return;
    const mq = window.matchMedia('(max-width: 900px)');
    const sections = document.querySelectorAll('.sobre-split');
    if (!sections.length) return;

    const items = Array.from(sections)
      .map((section) => {
        const media = section.querySelector('[data-sobre-split-media], .sobre-split__media');
        const img = section.querySelector('.sobre-split__img, .sobre-split__ph');
        if (!media || !img) return null;
        return { section, media, img };
      })
      .filter(Boolean);

    if (!items.length) return;

    let ticking = false;
    const reset = () => {
      items.forEach(({ img }) => {
        img.style.transform = '';
      });
    };

    const update = () => {
      if (mq.matches) {
        reset();
        ticking = false;
        return;
      }
      items.forEach(({ section, img }) => {
        const rect = section.getBoundingClientRect();
        const view = window.innerHeight || 1;
        if (rect.bottom < 0 || rect.top > view) return;
        const progress = Math.min(
          1,
          Math.max(0, (view - rect.top) / (view + Math.max(rect.height, 1)))
        );
        const shift = (progress - 0.5) * 42;
        img.style.transform = `scale(1.04) translate3d(0, ${shift}px, 0)`;
      });
      ticking = false;
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', onScroll);
    }
    update();
  }

  function boot() {
    reveal();
    heroParallax();
    splitParallax();
    scrollHint();
    momentsDrag();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => {
    (e.target || document).querySelectorAll('[data-u-reveal]').forEach((el) => el.classList.add('is-in'));
    reveal();
  });
})();
